<template>
  <section class="py-20 bg-gradient-to-br from-indigo-50 via-white to-purple-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <!-- Section Header -->
      <div class="text-center mb-16">
        <h2 class="text-4xl font-headings text-secondary-900 mb-4">
          The Smartest QR Codes in the Industry
        </h2>
        <p class="text-xl text-secondary-600 max-w-3xl mx-auto">
          Powerful, intelligent QR codes that seamlessly connect your physical and digital event experiences. Scan from
          anywhere, work everywhere.
        </p>
      </div>

      <!-- Main Visual Showcase -->
      <div class="mb-20">
        <div class="grid lg:grid-cols-2 gap-12 items-center">
          <!-- QR Code Visual -->
          <div class="order-2 lg:order-1 flex justify-center">
            <img :src="qrCodeImage" alt="QR Code" class="w-64 object-contain rounded-3xl shadow-2xl" style="transform: perspective(1000px) rotateX(0deg) rotateY(15deg) rotateZ(0deg);">
          </div>

          <!-- Key Features List -->
          <div class="order-1 lg:order-2 space-y-6">
            <div class="flex items-start gap-4 group">
              <Icon :icon="CameraIcon" variant="secondary"  />
              <div>
                <h3 class="text-xl font-headings text-secondary-900 mb-2">Scan from Outside the App</h3>
                <p class="text-gray-600">
                  Attendees can scan QR codes using any smartphone camera app or QR reader, making scanning quicker than ever.
                </p>
              </div>
            </div>

            <div class="flex items-start gap-4 group">
              <Icon :icon="ArrowDownTrayIcon" variant="secondary"  />
              <div>
                <h3 class="text-xl font-headings text-secondary-900 mb-2">Smart App Detection</h3>
                <p class="text-gray-600">
                  Automatically detects if users have your event app installed. If not, seamlessly redirects to download
                  pages for iOS or Android.
                </p>
              </div>
            </div>

            <div class="flex items-start gap-4 group">
              <Icon :icon="RectangleStackIcon" variant="secondary"  />
              <div>
                <h3 class="text-xl font-headings text-secondary-900 mb-2">Works Seamlessly Across All Features</h3>
                <p class="text-gray-600">
                  Effortlessly add QR codes to emails, name badges and apps to work with attendance tracking, lead
                  capture, gamification, lead generation, plugins and more.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { CameraIcon, ArrowDownTrayIcon, RectangleStackIcon } from '@heroicons/vue/24/outline'
import Icon from '@/components/Buttons/Icon.vue'
import qrCodeImage from '@/images/screenshots/web/theme-1-badge.png';

</script>

<style scoped>

</style>
